import EditSystemCalibrationCo2 from './containers/EditSystemCalibrationCo2Container'

export default EditSystemCalibrationCo2
